import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { CriarTransferenciaEstoqueRequest } from '../../requests/suprimentos/criar-transferencia-estoque.request';
import { AtualizarTransferenciaEstoqueRequest } from '../../requests/suprimentos/atualizar-transferencia-estoque.request';
import { GetTransferenciaEstoqueResponse } from '../../responses/suprimentos/get-transferencia-estoque.response';
import { GetTransferenciaEstoqueByIdResponse } from '../../responses/suprimentos/get-transferencia-estoque-by-id.response';
import { CriarTransferenciaEstoqueResponse } from '../../responses/suprimentos/criar-transferencia-estoque.response';
import { TransferenciaEstoqueLookupResponse } from '../../responses/suprimentos/transferencia-estoque-lookup.response';

@Injectable({ providedIn: 'root' })
export class TransferenciaEstoqueService extends CommonService {
  private readonly apiUrl: string = environment.urlApiSuprimentos + 'TransferenciaEstoque';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(params: {
    idStatus?: number;
    idLocalizacaoOrigem?: number;
    idLocalizacaoDestino?: number;
    dataInicio?: string;
    dataFim?: string;
    pagina?: number;
    tamanhoPagina?: number;
  }): Observable<GetTransferenciaEstoqueResponse> {
    let httpParams = new HttpParams();
    if (params.idStatus) httpParams = httpParams.set('idStatus', params.idStatus);
    if (params.idLocalizacaoOrigem) httpParams = httpParams.set('idLocalizacaoOrigem', params.idLocalizacaoOrigem);
    if (params.idLocalizacaoDestino) httpParams = httpParams.set('idLocalizacaoDestino', params.idLocalizacaoDestino);
    if (params.dataInicio) httpParams = httpParams.set('dataInicio', params.dataInicio);
    if (params.dataFim) httpParams = httpParams.set('dataFim', params.dataFim);
    if (params.pagina) httpParams = httpParams.set('pagina', params.pagina);
    if (params.tamanhoPagina) httpParams = httpParams.set('tamanhoPagina', params.tamanhoPagina);

    return this.httpClient
      .get<GetTransferenciaEstoqueResponse>(this.apiUrl, { params: httpParams, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getLookup(): Observable<TransferenciaEstoqueLookupResponse> {
    return this.httpClient
      .get<TransferenciaEstoqueLookupResponse>(`${this.apiUrl}/lookup`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getById(idTransferenciaEstoque: number): Observable<GetTransferenciaEstoqueByIdResponse> {
    return this.httpClient
      .get<GetTransferenciaEstoqueByIdResponse>(`${this.apiUrl}/${idTransferenciaEstoque}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public criar(request: CriarTransferenciaEstoqueRequest): Observable<CriarTransferenciaEstoqueResponse> {
    return this.httpClient
      .post<CriarTransferenciaEstoqueResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public atualizar(idTransferenciaEstoque: number, request: AtualizarTransferenciaEstoqueRequest): Observable<CriarTransferenciaEstoqueResponse> {
    return this.httpClient
      .put<CriarTransferenciaEstoqueResponse>(`${this.apiUrl}/${idTransferenciaEstoque}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluir(idTransferenciaEstoque: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/${idTransferenciaEstoque}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
